var map = {
	"./altri-report.svg": "a403",
	"./auto-riservate-white.svg": "cc128",
	"./auto-riservate.svg": "e0df",
	"./avviso-white.svg": "2d2e",
	"./avviso.svg": "28cd",
	"./calendar.svg": "b8bd",
	"./cambio.svg": "127e",
	"./carstock.svg": "7ddc",
	"./cerca-auto-white.svg": "b60c",
	"./cerca-auto.svg": "5e61",
	"./clienti.svg": "d67d",
	"./contratti-privati.svg": "73a8",
	"./contratti-rivenditori.svg": "97fe",
	"./crm.svg": "f225",
	"./dashboard.svg": "ecef",
	"./elenco-white.svg": "e02d",
	"./elenco.svg": "257e",
	"./engine.svg": "b6e4",
	"./favorite-white.svg": "ba28",
	"./favorite.svg": "2bd7",
	"./fornitori-white.svg": "e642",
	"./fornitori.svg": "853f",
	"./fuel.svg": "dde1",
	"./impostazioni.svg": "a6ca",
	"./miei-avvisi-white.svg": "fad1",
	"./miei-avvisi.svg": "b3f4",
	"./multipubblicazione.svg": "93a7",
	"./newsletter.svg": "8222",
	"./parco-auto-white.svg": "eb03",
	"./parco-auto.svg": "3c80",
	"./personale.svg": "6138",
	"./preventivi-white.svg": "a69f",
	"./preventivi.svg": "aece",
	"./report.svg": "effc",
	"./rivenditori-white.svg": "50aa",
	"./rivenditori.svg": "5e2c",
	"./road.svg": "188f",
	"./support-white.svg": "53c9",
	"./support.svg": "33f5",
	"./waving-hand.svg": "499d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";